// removed by extract-text-webpack-plugin
module.exports = {"receipt-list-item-box":"app-components-receipt-invoices-ListItemBox-__ListItem___1Xh_z"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/invoices/ListItemBox/ListItem.css
// module id = 752
// module chunks = 0